import { z } from 'zod';
import { id } from '../../../common/atomic/id';
import { date } from '../../../common/atomic/date';
import { dateTime } from '../../../common/atomic/dateTime';
import { careTakerSchema } from '../../../common/basic/careTaker';
import { pageableSchema } from '../../pageable/response';

export const carePlanSchema = z.object({
  carePlanId: id,
  serviceId: id,
  applicantId: id,
  nextRevDate: date,
});

const carePlansSchema = z
  .object({
    content: z.array(carePlanSchema),
  })
  .merge(pageableSchema);

export const carePlanDetailedSchema = z.object({
  id,
  applicantId: id.nullable(),
  mobility: z.string(),
  goal: z.string(),
  healthDesc: z.string(),
  sitDesc: z.string(),
  risks: z.string(),
  reqCare: z.string(),
  note: z.string(),
  noteCoord: z.string(),
  noteCaregiver: z.string(),
  clientRes: z.string(),
  createdAt: dateTime,
  lastRevDate: date,
  nextRevDate: date,
  expDate: date,
  serviceId: z.number(),
  keyEmp: careTakerSchema,
  clientId: z.number(),
  active: z.boolean(),
});

export type CarePlan = z.infer<typeof carePlanSchema>;
export type CarePlans = z.infer<typeof carePlansSchema>;
export type CarePlanDetailed = z.infer<typeof carePlanDetailedSchema>;
